/* eslint-disable react-hooks/exhaustive-deps */
import { ChangeEvent, FC, useEffect, useState } from "react";
import "./Generated.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { draw, Inputs, rank } from "../../model/inputs.model";
import { getComplessPhoto } from "../../app/getComplessPhoto";
import axios from "axios";
import { useDrawCanvas } from "../../app/useDrawCanvas";
import { Rings } from "react-loader-spinner";

interface GeneratedProps {}

const Generated: FC<GeneratedProps> = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [photos, setPhotos] = useState<File[]>([]);
  const [rankPhotos, setRankPhotos] = useState<rank[]>([]);
  const [loading, setLoading] = useState(true);
  const [drawparams, setDrawparams] = useState<draw>();
  const [isValid, setIsValid] = useState(false);
  const [isFinish, setIsFinish] = useState(false);
  const [inputData, setInputData] = useState<Inputs>({
    title: "",
    subtitle: "",
  });

  const baseURL = process.env.REACT_APP_API_URL;
  const ranks: rank[] = [];
  const limit = 6;
  const { ctx } = useDrawCanvas(drawparams);

  useEffect(() => {
    setPhotos(location.state as File[]);
    window.scrollTo(0, 0);
  }, [location.state]);

  useEffect(() => {
    if (photos) {
      const promises = photos.map(async (item) => {
        const comp = await getComplessPhoto(item);
        try {
          axios({
            url: baseURL,
            method: "POST",
            data: comp,
            headers: { "Content-Type": "image/jpeg" },
          })
            .then((response) => {
              let result = {
                mean: (response.data.mean * 1000).toFixed(),
                file: comp,
              } as rank;
              ranks.push(result);
            })
        .then(()=>{
          if(ranks.length>=limit){
            setRankPhotos(ranks.slice(0, limit).sort((a, b) => b.mean - a.mean));
          }
        })
        .then(() => {
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
        } catch (error) {
          alert("エラーが発生しました。");
        }
      });
      Promise.all(promises);
    }
  }, [photos]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
    if (name === "title") {
      value.length > 1 ? setIsValid(true) : setIsValid(false);
    }
    if (value.length < 1) {
      setInputData({ ...inputData, [name]: "" });
    }
  };

  const handleBlur = () => {
    const params = {
      title: inputData.title,
      subtitle: inputData.subtitle,
      data: rankPhotos,
    } as draw;
    setDrawparams(params);
  };

  useEffect(() => {
    if (isFinish) {
      const dataURL = ctx.canvas.toDataURL("image/png", 0.85);
      const blob = toBlob(dataURL);
      const imageFile = new File([blob], "image.png", {
        type: "image/png",
      });

      sessionStorage.clear();
      navigate("/comprete", { state: imageFile, replace: true });
    }
  });

  //Web Share API Level 2
  const handleShere = async () => {
    const dataURL = ctx.canvas.toDataURL();
    const blob = toBlob(dataURL);
    const imageFile = new File([blob], "image.png", {
      type: "image/png",
    });

    try {
      await navigator.share({
        title: "example app",
        text: window.location.protocol + "//" + window.location.host,
        url: window.location.protocol + "//" + window.location.host,
        files: [imageFile],
      });
      setIsFinish(true);
    } catch (error) {
      console.log(error);
      setIsFinish(false);
    }
  };

  // 画像保存
  const handleDownload = async () => {
    const dataURL = ctx.canvas.toDataURL("image/png", 0.85);
    const link = document.createElement("a");
    link.download = "image.png";
    link.href = dataURL;
    link.click();
    link.remove();
    setTimeout(() => {
      URL.revokeObjectURL(dataURL);
      setIsFinish(true);
    }, 1e4 / 1.5);
  };

  return (
    <div className="Generated" data-testid="Generated">
      {loading ? (
        <div className="loading">
          <Rings
            height="80"
            width="80"
            color="#ccc"
            radius="6"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="rings-loading"
          />
        </div>
      ) : (
        <div></div>
      )}

      {rankPhotos.length > 0 && (
        <>
          <div className="header">
            <h2>ランキング画像を作成しました！</h2>
            <p>
              グレーの入力エリアをタップして
              <br />
              タイトル・サブタイトルを入力しましょう
            </p>
          </div>
          <div className="container">
            {[...Array(limit)].map((_, index) =>
              index < rankPhotos.length && (
                <div className="box" key={index + 1}>
                  <img
                    src={(window.URL || window.webkitURL).createObjectURL(
                      rankPhotos[index].file
                    )}
                    alt={`あなたの写真 ${index + 1}`}
                  />
                  <div className={`label rank${index + 1}`}></div>
                </div>
              )
            )}
            <form>
              <input
                id="Title"
                name="title"
                className="title"
                type="text"
                placeholder="タップしてタイトルを入力"
                onChange={handleChange}
                value={inputData.title}
                onBlur={handleBlur}
              />
              <input
                id="SubTitle"
                name="subtitle"
                className="subTitle"
                type="text"
                placeholder="タップしてサブタイトルを入力"
                onChange={handleChange}
                value={inputData.subtitle}
                onBlur={handleBlur}
              />
            </form>
          </div>
          <div>
            <div id="step2" className="step">
              <button disabled={!isValid} onClick={handleDownload}>
                スマホに保存する
              </button>
              <button disabled={!isValid} onClick={handleShere}>
                SNSに投稿する
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Generated;

const toBlob = (base64: string) => {
  const decodedData = atob(base64.replace(/^.*,/, ""));
  const buffers = new Uint8Array(decodedData.length);
  for (let i = 0; i < decodedData.length; i++) {
    buffers[i] = decodedData.charCodeAt(i);
  }
  try {
    const blob = new Blob([buffers.buffer], {
      type: "image/png",
    });
    return blob;
  } catch (e) {
    return null;
  }
};
